<template>
    <div class="share-report-container">
        <share-report :data="data" v-if="data"></share-report>
    </div>
</template>
<script>
import ShareReport from "@/components/share-report/ShareReport.vue";
 export default {
     data(){
         return {
             data:null
         }
     },
     created(){
        this.getData();         
     },
     methods:{
      getData() {
        this.$http({
          loading: true,
          url: "/bdzb-core-service/eva/evaluateResult",
          data: {},
          method: "POST",
        }).then((data) => {
          this.data = data;
        })
      }
     },
    components: {
        ShareReport
    },    
 }
</script>
<style scoped>

</style>